























































































































import { LeadService, PesquisarLeadsCommand } from "@/services/lead.service";
import ComboUsuarioResponsavel from "@/shared/components/ComboUsarioResponsavel.vue";
import DateRange from "@/shared/components/date-range.vue";
import moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import ComboCanalLead from "./ComboCanalLead.vue";
import ComboEtapaLead from "./ComboEtapaLead.vue";
import ComboMotivoLead from "./ComboMotivoLead.vue";
import ComboStatusLead from "./ComboStatusLead.vue";
import ComboTipoLead from "./ComboTipoLead.vue";

import { telefone } from "@/shared/filters";

@Component({
  components: {
    ComboTipoLead,
    ComboCanalLead,
    ComboEtapaLead,
    ComboStatusLead,
    ComboMotivoLead,
    ComboUsuarioResponsavel,
    DateRange,
  },
})
export default class PesquisarLeadsFiltro extends Vue {
  msgFiltro = "Mostrar Filtros";
  formAtivo = 0;
  filtros = {} as PesquisarLeadsCommand;
  periodo = "";
  telefone = "";

  created() {
    this.getFiltros();
  }

  getFiltros() {
    this.filtros.nome = this.$route.query.nome as string;
    this.filtros.dataFim = this.getDate("dataFim");
    this.filtros.dataInicio = this.getDate("dataInicio");
    this.filtros.offset = 0;
    this.filtros.order = this.$route.query.order as string;
    this.telefone = telefone(
      (this.filtros.telefone = this.getNumber("telefone"))?.toString() ?? ""
    );
    this.filtros.idCanalLead = this.getNumber("idCanalLead");
    this.filtros.idEtapaLead = this.getNumber("idEtapaLead");
    this.filtros.idMotivoLead = this.getNumber("idMotivoLead");
    this.filtros.idStatusLead = this.getNumber("idStatusLead");
    this.filtros.idTipoLead = this.getNumber("idTipoLead");
    this.filtros.idUsuario = this.getNumber("idUsuario");
    this.filtros.limit = this.getNumber("limit", 25);

    if (this.filtros.dataInicio && this.filtros.dataFim) {
      this.periodo = `${moment(this.filtros.dataInicio).format(
        "DD/MM/YYYY"
      )} - ${moment(this.filtros.dataFim).format("DD/MM/YYYY")}`;
    }
  }

  private getDate(key: string) {
    const n = this.$route.query[key] as string;
    return (n && moment(n).toDate()) || undefined;
  }

  private getNumber<T = number | undefined>(key: string, defaultValue?: T): T {
    const n = this.$route.query[key];
    return (n && !isNaN(+n) ? +n : defaultValue) as T;
  }

  pesquisar() {
    this.getFormValues();

    const query = this.serialize();
    this.$router.replace({ query });
  }

  getFormValues() {
    this.filtros.offset = 0;
    this.filtros.limit =
      (this.$route.query.limit && +this.$route.query.limit) || 25;
    this.filtros.order =
      this.$route.query.order && "" + this.$route.query.order;

    delete this.filtros.dataFim;
    delete this.filtros.dataInicio;
    delete this.filtros.telefone;

    if (this.periodo) {
      const keys = this.periodo.split("-");
      const momentInicio = moment(keys[0].trim(), "DD/MM/YYYY");
      const momentFim = moment(keys[1].trim(), "DD/MM/YYYY");
      this.filtros.dataInicio =
        (momentInicio.isValid() && momentInicio.toDate()) || undefined;
      this.filtros.dataFim =
        (momentFim.isValid() && momentFim.toDate()) || undefined;
    }

    if (this.telefone) {
      const numeroTelefoneFormatado = this.telefone.replace(/([^\d])+/gim, "");
      this.filtros.telefone = +numeroTelefoneFormatado;
    }

    return this.filtros;
  }

  async exportar() {
    const filtros = this.getFormValues();
    await LeadService.exportarPesquisaLead(filtros);
  }

  async exportarOcta() {
    const filtros = this.getFormValues();
    await LeadService.exportarPesquisaLeadOcta(filtros);
  }

  serialize() {
    const map = {} as { [key: string]: string };
    const filtros = this.filtros as { [key: string]: any };
    for (const key in filtros) {
      let value = filtros[key];
      if (value) {
        if (value instanceof Date) {
          value = moment(value).toJSON();
        }
        map[key] = value;
      }
    }

    return map;
  }

  changeMsgPanel() {
    if (this.msgFiltro == "Mostrar Filtros") {
      this.msgFiltro = "Fechar Filtros";
    } else {
      this.msgFiltro = "Mostrar Filtros";
    }
  }
}
